<template>
    <Auth title="Reset Password">
        <template #heading>
            <h1 class="fw-bold mb-2">Reset Password</h1>
            <p class="fw-medium text-muted">Input your new password.</p>
        </template>
        <Alert ref="alert" class="alert-danger">
            {{ message }}
        </Alert>
        <Form ref="form" @submit="onSubmit">
            <InputField id="password" v-model="password" name="password" rules="required" label="Password" type="password" placeholder="password" />

            <InputField id="password_confirmation" v-model="password_confirmation" name="password_confirmation" rules="required" label="Confirm Password" type="password" placeholder="confirm password" />

            <div class="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <Link :href="route('login')" class="text-muted fs-sm fw-medium d-block d-lg-inline-block mb-1">Log in</Link>
                </div>
                <div>
                    <Button id="action" type="submit" :label="labels" :loading="loading" :done="done" class="btn-lg btn-alt-primary" />
                </div>
            </div>
        </Form>
    </Auth>
</template>

<script lang="ts">
import { error } from '@/ts/app'
import Alert from '@/vue/components/Alert.vue'
import { ButtonLabel } from '@/vue/components/Button'
import Button from '@/vue/components/Button.vue'
import Form from '@/vue/components/Form.vue'
import InputField from '@/vue/components/InputField.vue'
import Link from '@/vue/components/Link.vue'
import Auth from '@/vue/templates/Auth.vue'
import { AxiosError } from 'axios'
import { Component, Prop, Ref, Vue, Watch, toNative } from 'vue-facing-decorator'

@Component({
    components: {
        Auth,
        Alert,
        InputField,
        Form,
        Button,
        Link
    },
})
class ResetPassword extends Vue {

    message = ''

    password = ''
    password_confirmation = ''

    loading = false
    done = false

    @Ref('form')
    readonly form!: InstanceType<typeof Form>

    @Ref('alert')
    readonly alert!: InstanceType<typeof Alert>

    @Prop({ type: String })
    readonly email!: string

    @Watch('message')
    onMessageChanged(value: string) {
        const alert: HTMLDivElement = this.alert.$el
        if (value.length > 0) {
            alert.classList.add('show')
        } else {
            alert.classList.remove('show')
        }
    }

    get labels(): ButtonLabel {
        return {
            normal: 'Reset',
            loading: 'Resetting',
            done: 'Done',
        } as ButtonLabel
    }

    async onSubmit(payload) {
        this.loading = true
        this.message = ''
        payload = {
            ...payload,
            email: this.email,
        }
        this.$http
            .post(this.route('auth.ajax.password.reset'), payload)
            .then(() => {
                this.done = true
                this.router.replace(this.route('login'))
            })
            .catch((e: AxiosError) => error(e, this))
            .finally(() => (this.loading = false))
    }
}

export default toNative(ResetPassword)
</script>
